module.exports = __webpack_public_path__ + "static/flags/SH-d20e00e868c39f5403185d34cd80fc4f.gif";